/* ============================================================
   éclat — advertorial behaviour
   Identical logic to the original inline <script>. Only difference:
   it is safe to load more than once, it survives sections being
   added/removed/reordered in the theme editor, and every lookup is
   null-guarded so a disabled section can never break the rest.
   ============================================================ */
(function () {
  if (window.__eclatAdvertorial) return;
  window.__eclatAdvertorial = true;

  /* ---------- countdown (unchanged maths: midnight 23:59) ---------- */
  function left() {
    var n = new Date(), e = new Date(n.getFullYear(), n.getMonth(), n.getDate(), 23, 59, 0);
    if (e <= n) e.setDate(e.getDate() + 1);
    var t = Math.floor((e - n) / 1000);
    return {
      h: String(Math.floor(t / 3600)).padStart(2, '0'),
      m: String(Math.floor(t % 3600 / 60)).padStart(2, '0'),
      s: String(t % 60).padStart(2, '0')
    };
  }
  function paint() {
    var r = left();
    document.querySelectorAll('[data-u]').forEach(function (el) { el.textContent = r[el.dataset.u]; });
    var t = r.h + ':' + r.m + ':' + r.s;
    document.querySelectorAll('[data-tick]').forEach(function (el) { el.textContent = t; });
  }

  /* ---------- product shelf + filters ---------- */
  function initShelf(root) {
    var wraps = root.querySelectorAll('[data-eclat-shelf]');
    wraps.forEach(function (scope) {
      if (scope.dataset.eclatBound === 'true') return;
      scope.dataset.eclatBound = 'true';

      var shelf = scope.querySelector('.shelf');
      var prev = scope.querySelector('.snav.prev');
      var next = scope.querySelector('.snav.next');
      var f = scope.querySelectorAll('.filters button');
      var p = scope.querySelectorAll('.shelf .prod');
      if (!shelf) return;

      function arrows() {
        if (!prev || !next) return;
        var max = shelf.scrollWidth - shelf.clientWidth - 2;
        prev.disabled = shelf.scrollLeft <= 2;
        next.disabled = shelf.scrollLeft >= max;
      }
      function step(dir) {
        var card = shelf.querySelector('.prod:not([hidden])');
        var w = card ? card.getBoundingClientRect().width + 20 : 276;
        var per = Math.max(1, Math.round(shelf.clientWidth / w));
        shelf.scrollBy({ left: dir * w * per, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      shelf.addEventListener('scroll', arrows, { passive: true });
      window.addEventListener('resize', arrows);
      arrows();

      f.forEach(function (b) {
        b.addEventListener('click', function () {
          f.forEach(function (x) { x.setAttribute('aria-selected', 'false'); });
          b.setAttribute('aria-selected', 'true');
          p.forEach(function (c) {
            var show = (b.dataset.f === 'all' || c.dataset.cat.split(' ').indexOf(b.dataset.f) > -1);
            c.hidden = !show;
          });
          shelf.scrollTo({ left: 0, behavior: 'smooth' });
          setTimeout(arrows, 320);
        });
      });
    });
  }

  /* ---------- bundle selector in the buy box ---------- */
  function initBundles(root) {
    var boxes = root.querySelectorAll('[data-eclat-bundles]');
    boxes.forEach(function (scope) {
      if (scope.dataset.eclatBound === 'true') return;
      scope.dataset.eclatBound = 'true';

      var bcards = scope.querySelectorAll('.bcard');
      var bcta = scope.querySelector('[data-eclat-cta]');
      if (!bcards.length) return;

      function pick(card) {
        bcards.forEach(function (c) {
          c.classList.remove('on');
          var i = c.querySelector('input');
          if (i) i.checked = false;
        });
        card.classList.add('on');
        var inp = card.querySelector('input');
        if (!inp) return;
        inp.checked = true;
        if (bcta && inp.dataset.url) bcta.href = inp.dataset.url;
      }
      bcards.forEach(function (c) {
        c.addEventListener('click', function () { pick(c); });
        var i = c.querySelector('input');
        if (i) i.addEventListener('change', function () { pick(c); });
      });
      var sel = scope.querySelector('.bcard.on');
      var selInput = sel ? sel.querySelector('input') : null;
      if (selInput && bcta && selInput.dataset.url) bcta.href = selInput.dataset.url;
    });
  }

  /* ---------- sticky bar + reading progress ---------- */
  function onScroll() {
    var s = document.getElementById('sticky');
    var g = document.getElementById('prog');
    if (s) s.classList.toggle('on', window.scrollY > 900);
    if (g) {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      g.style.width = (h > 0 ? window.scrollY / h * 100 : 0) + '%';
    }
  }

  /* ---------- boot ---------- */
  function initAll(root) {
    root = root || document;
    initShelf(root);
    initBundles(root);
    paint();
    onScroll();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  setInterval(paint, 1000);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* theme editor: re-bind whatever section was just re-rendered */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function () { onScroll(); });
})();
